/**
 * @file toast-constants.ts
 *
 * Immutable constants for the admin toast helper: the per-variant Gravity icon
 * assets and the enter / auto-dismiss / exit timings. Kept separate from
 * `toast.ts` so the behavioural logic stays free of the Gravity asset imports
 * and the magic numbers (mirroring `shipping-constants.ts`).
 */

import errorIcon from '@group.one/gravity/dist/icons/error.svg';
import warningIcon from '@group.one/gravity/dist/icons/warning.svg';
import infoIcon from '@group.one/gravity/dist/icons/info.svg';
import successIcon from '@group.one/gravity/dist/icons/check_circle.svg';
import closeIcon from '@group.one/gravity/dist/icons/close.svg';

/** Visual style of a toast, matching Gravity's `gv-toast-*` modifiers. */
export type ToastVariant = 'success' | 'alert' | 'warning' | 'info';

/** Default auto-dismiss delay, in milliseconds. */
export const TOAST_DEFAULT_DURATION = 4000;

/** Delay before the enter-transition class is applied, in milliseconds. */
export const TOAST_VISIBLE_DELAY = 60;

/** Exit-transition duration before the node is detached, in milliseconds. */
export const TOAST_REMOVE_TRANSITION = 250;

/** Maps each variant to its Gravity icon asset. */
export const TOAST_VARIANT_ICONS: Record<ToastVariant, string> = {
  alert: errorIcon,
  warning: warningIcon,
  info: infoIcon,
  success: successIcon,
};

/** The Gravity close-icon asset for the toast dismiss button. */
export const TOAST_CLOSE_ICON = closeIcon;
